import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderOutTeam() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 2,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 8,
                        spaceBetween: 0,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >

                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/orthopedic"><img src="assets/img/Orthopedic.jpg" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black" }}>Orthopedic</p>
                        </div></li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/ent"><img src="assets/img/नाक, कान, गला रोग विभाग.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black" }}>नाक, कान, गला रोग विभाग</p>
                        </div></li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/general-surgery"><img src="assets/img/General Surgery.jpg" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black" }}>General Surgery</p>
                        </div></li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/general-medicine"><img src="assets/img/General Medicine.jpg" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black", fontSize: "15px" }}>General Medicine</p>
                        </div></li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/neurology"><img src="assets/img/Neurology.jpg" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black" }}>Neurology</p>
                        </div></li>
                </SwiperSlide>
                
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/neurosurgery"><img src="assets/img/Neurosurgery.jpg" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black" }}>Neurosurgery</p>
                        </div></li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/physiotherapist"><img src="assets/img/Physiotherapist.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black" }}>Physiotherapist</p>
                        </div></li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/gynaecology"><img src="assets/img/Gynaecology.jpg" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black" }}>Gynaecology</p>
                        </div></li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/neuropsychiatrist"><img src="https://res.cloudinary.com/dedml8dsw/image/upload/v1770098845/neuropsychiatris_qdlo7v.jpg" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black" }}>Neuropsychiatrist</p>
                        </div></li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/paediatrics"><img src="assets/img/Paediatrics.png" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black" }}>Paediatrics</p>
                        </div></li>
                </SwiperSlide>


                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/gastroenterology"><img src="assets/img/Gastroenterology.jpg" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black" }}>Gastroenterology</p>
                        </div></li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/dental"><img src="assets/img/Dental.jpg" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "center", color: "black" }}>Dental</p>
                        </div></li>
                </SwiperSlide>
                







            </Swiper>
        </>
    );
}
